module.exports = __webpack_public_path__ + "img/guide_phone.4f44ad46.png";